import axios from "../../../../api/axios";

export type GinoAddOns = {
  code: string;
  credits: number;
  currency: string;
  description: string;
  id: number;
  isActive: boolean;
  priceCents: number;
  title: string;
};

export const getGinoAddOns = async (): Promise<GinoAddOns[]> => {
  const response = await axios.get("/gino-tokens/addons");
  return response.data.data;
};
